// @flow

import React, { useState } from "react";
import { Button, ConfirmationModalLauncher, Text } from "buba-components";
import { logError } from "buba-components/src/utils/loggers";

type SetStatusModalLauncherProps = {
  id: number,
  triggerButtonText: string,
  contentText: string,
  setStatusAction: number => Promise<>,
  requestFetch: () => void,
  displayErrorForStatusCode: (?number) => void,
  statusName: string
};

const SetStatusModalLauncher = ({
  id,
  triggerButtonText,
  contentText,
  setStatusAction,
  requestFetch,
  displayErrorForStatusCode,
  statusName
}: SetStatusModalLauncherProps) => {
  const [isRequestRunning, setRequestRunning] = useState(false);

  return (
    <ConfirmationModalLauncher
      trigger={({ open }) => (
        <Button onClick={open} size="small">
          {triggerButtonText}
        </Button>
      )}
      content={() => <Text>{contentText}</Text>}
      confirmButtonText="Ja"
      declineButtonText="Nein"
      isConfirmButtonDisabled={isRequestRunning}
      isDeclineButtonDisabled={isRequestRunning}
      confirmAction={({ close }) => {
        setRequestRunning(true);
        return setStatusAction(id)
          .then(() => {
            requestFetch();
            close();
            setRequestRunning(false);
          })
          .catch(error => {
            displayErrorForStatusCode(error.response.status);
            logError(`Error while setting status ${statusName}`, error);
            close();
            setRequestRunning(false);
          });
      }}
      declineAction={({ close }) => close()}
    />
  );
};

export default SetStatusModalLauncher;
